import styled from 'styled-components';

export const Container = styled.div`
  background: var(--background-color);
  border-radius: 4px;
  width: 100%;
  box-shadow: var(--box-shadow);
`;

export const Filters = styled.div`
  background: var(--background-color);
  box-shadow: var(--box-shadow);
  border-bottom: 1px solid #c0c0c0;
`;

export const Options = styled.div`
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #c0c0c0;
  background: var(--background-color);
  @media (max-width: 800px) {
    position: initial;
    flex-direction: column;
    padding: 10px;
  }
`;

export const SearchBar = styled.div`
  padding-right: 10px;
  justify-content: center;
  color: var(--color);
  align-items: center;
  display: flex;
  outline: 1px solid var(--color);
  transition: all 0.3s ease;
  &:hover {
    outline: 1px solid #c0c0c0;
  }
  @media (max-width: 800px) {
    margin-top: 10px;
    width: 100%;
  }
`;

export const SearchInput = styled.input`
  padding: 10px 5px;
  color: var(--color);
  width: 300px;
  border: none;
  outline: none;
  font-size: 1.4rem;

  background: none;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif;

  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const Title = styled.h1`
  font-family: 'GothamBold', Arial, Helvetica, sans-serif;
  color: var(--color);
  font-size: 2rem;
`;

export const TableScroll = styled.div`
  overflow: auto;
  height: calc((100vh - 240px));
`;

export const Table = styled.table`
  border-collapse: collapse;
  text-align: left;
  width: 100%;
`;

export const Tr = styled.tr`
  border-bottom: solid 1px #e0e0e0;
`;

export const Tbody = styled.tbody``;

export const Pages = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  color: var(--color);
  background: var(--background-color);
  padding: 0 6px;
  @media (max-width: 1030px) {
    flex-direction: column;
    margin-top: 15px;
  }
`;

export const PageItems = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  gap: 10px;
  @media (max-width: 739px) {
    &:first-child {
      display: none;
    }
  }
`;

export const FilterPage = styled.div`
  display: flex;
  align-items: center;
  color: var(--color);
  justify-content: center;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`;

export const RowTable = styled.div`
  display: flex;
  color: var(--color);
  align-items: center;
  justify-content: center;
  margin-left: 10px;
  @media (max-width: 739px) {
    &:first-child {
      display: none;
    }
  }
`;

export const Label = styled.label`
  margin-right: 10px;
  color: var(--color);
  font-family: 'GothamLight', Arial, Helvetica, sans-serif; ;
`;

export const Select = styled.select`
  font-family: 'GothamLight', Arial, Helvetica, sans-serif;

  background: transparent;
  color: var(--color);
  outline: 1px solid var(--color);
  padding: 5px;
  border: none;
  transition: all 0.3s ease;
  &:hover {
    outline: 1px solid #c0c0c0;
  }
  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const ArrowPrevNext = styled.button`
  cursor: pointer;
  background: transparent;
  color: var(--color);
  outline: none;
  border: none;
  min-width: 50px;
  min-height: 50px;
  transition: all 0.3s ease;
  &:disabled {
    color: #000000;
    opacity: 0.3;
  }
`;

export const Option = styled.option`
  color: #000;
  font-family: 'GothamLight', Arial, Helvetica, sans-serif; ;
`;

export const WithoutData = styled.div`
  padding: 40px 0;
  h1 {
    font-size: 2.4rem;
    text-align: center;
  }
`;
